import { Injectable } from '@angular/core';
import { BaseApiService } from '../../../shared/base-service/base-api.service';

@Injectable()
export class FinanceLookupService extends BaseApiService {

    /**
     * Gets the finance lookups
     */
    public getLookups() {
        return this.get('Finance/Lookup');
    }

    /**
     * Gets the finance distribution rule source types
     */
    public getFinanceGLAccountTypes() {
        return this.get('Finance/Lookup/financeglaccounttype');
    }

    /**
     * Gets the current fiscal year
     */
    public getCurrentFiscalYear() {
        return this.get('Finance/Lookup/FiscalYear/Current');
    }

    /**
     * Gets the previous fiscal year
     */
    public getPreviousFiscalYear() {
        return this.get('Finance/Lookup/FiscalYear/Previous');
    }

    /**
     * Gets the fiscal years
     */
    public getFiscalYears() {
        return this.get('Finance/Lookup/FiscalYear');
    }

    /**
     * Gets the fiscal years, distinct by year
     */
    public getDistinctFiscalYears() {
        return this.get('Finance/Lookup/FiscalYear/Distinct');
    }

    /**
     * Gets the list of fiscal period records that match the provided fiscal year.
     * @param fiscalYear the fiscal year.
     */
    public getAllFiscalPeriodsForFiscalYear(fiscalYear: any) {
        return this.get(`Finance/Lookup/FiscalYear/Periods/${fiscalYear}`);
    }

    /**
     * Gets the Fiscal Year record that matches the provided fiscal year, with the earliest starting effective date.
     * @param fiscalYear the fiscal year.
     */
    public getStartingFiscalPeriodForFiscalYear(fiscalYear: number) {
        return this.get(`Finance/Lookup/FiscalYear/Start/${fiscalYear}`);
    }

    /**
     * Gets the fiscal years for the given date range
     * @param criteria The fiscal year search criteria
     */
    public searchFiscalYears(criteria) {
        return this.post('Finance/Lookup/FiscalYear', criteria);
    }

    /**
     * Gets the finance highway fund bucket types
     * @returns a list of highway fund bucket types
     */
    public getFinanceHighwayFundBucketTypes() {
        return this.get('Finance/Lookup/FinanceHighwayFundBucketTypes');
    }

    /**
     * Gets the finance journal entry types
     * @returns a list of journal entry types
     */
    public getFinanceJournalEntryTypes() {
        return this.get('Finance/Lookup/FinanceJournalEntryTypes');
    }

    /**
     * Gets the finance disbursement request types
     * @returns a list of disbursement request types
     */
    public getFinanceDisbursementRequestTypes() {
        return this.get('Finance/Lookup/FinanceDisbursementRequestTypes');
    }

    /**
     * Gets the finance rental surcharge adjustment products
     * @returns a list of products
     */
    public getFinanceRentalSurchargeAdjustmentProducts() {
        return this.get('Finance/Lookup/FinanceRentalSurchargeAdjustmentProducts');
    }

    /**
     * Gets the products for miscellaneous purchase transactions
     * @returns a list of products
     */
    public getProductsForMiscellaneousPurchaseTransaction() {
        return this.get('Finance/Lookup/MiscellaneousPurchaseProducts');
    }

    /**
     * Gets the payment types that are disallowed for the current BU.
     * @returns The payment types that are disallowed for the current BU.
     */
    public getPaymentMethodTypeBusinessUnitExclusionMaps() {
        return this.get('Finance/Lookup/PaymentMethodTypeBusinessUnitExclusionMaps');
    }

    /**
     * Gets the finance disbursement request denial reason types
     * @returns a list of disbursement request denial reason types
     */
    public getFinanceDisbursementFuelTaxRequestDenialReasonTypes() {
        return this.get('Finance/Lookup/FinanceDisbursementFuelTaxRequestDenialReasonType');
    }
}
